import React from 'react';

import RRPieChart from 'legacy/main/components/common/charts/rrPieChart';

const DonutPieChart = ({ title = null, data }) => (
    <RRPieChart title={title} data={data} nameKey="label" dataKey={(row) => row.rooms.guaranteed} />
);

export default DonutPieChart;
